const SERVER_BASE = "xxx.com";

module.exports = {
  SERVER: {
    API_SERVER: `https://api.${SERVER_BASE}`,
  },
};
